"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../../pages/TermsAndConditions/styles.module.scss"));
var TermsConditionsText = function (_a) {
    var header = _a.header, text = _a.text;
    var t = react_i18next_1.useTranslation('common').t;
    var privacy_policy = react_1.useRef(null);
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.terms), ref: privacy_policy },
        react_1.default.createElement("h2", null,
            " ",
            header),
        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: text } })));
};
exports.default = TermsConditionsText;
